import { http } from "../plugins/http";
import { baseApiUrl } from "../config";

//
// Os endpoints /v1/cte/faturas/** sairam da cte-engine-api e passaram a ser
// servidos pela cte-app-web-api (o BFF do portal) - mesma migracao feita para
// /v1/certificados e /v1/financeiro. Antes as chamadas estavam hardcoded nos
// callers, algumas apontando para a URL do Cloud Run da engine.
//
export default {

  //
  // Debitos dos transportadores vinculados ao usuario.
  // status: 1 = pendente, 3 = pago (default 1 no backend).
  //
  getPendentesUsuario: (idUsuario, status) => {
    return http.get("/v1/cte/faturas/pendentesUsuario", {
      params: { idUsuario, status },
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  //
  // URL do PDF da fatura do periodo. Devolvida como string porque os callers
  // baixam via fetch/axios com responseType blob e o Bearer no header
  // (downloadPDF em Faturas.vue e FaturasPendentes.vue).
  // baseApiUrl ja termina com barra (VUE_APP_BASE_URL).
  //
  urlFaturaPdf: (cnpj, ano, mes) => {
    return `${baseApiUrl}v1/cte/faturas/${cnpj}/referencia/${ano}/${mes}`;
  },

};
